import { useNavigate } from "react-router-dom";

import { HEALTH_CHECK_QUERY_KEY } from "@/components/Core/HealthGate/data";
import { routers } from "@/configs";
import { releasePushOnLogout } from "@/lib/pwa";
import { queryClient } from "@/lib/queryClient";
import { logoutUser } from "@/services";
import { dispatch, logout, persister } from "@/store";

/**
 * Signs the player out in place. It used to reload the page, which went back
 * through the health check and the loading clouds; now the account's cached
 * data (balance, grants, standing) is dropped, the socket reconnects as a
 * guest on its own (it follows the token), and the lobby is shown. The lobby
 * comes first so a page that needs an account is gone before it can ask for
 * one.
 */
export function useLogout() {
  const navigate = useNavigate();

  const signOut = async () => {
    // The server ends the session first (it needs the token); the browser is cleared either way.
    await releasePushOnLogout();
    try {
      await logoutUser();
    } catch (error) {
      console.warn("Logout request failed:", error);
    }
    navigate(routers.Home);
    dispatch(logout());
    queryClient.removeQueries({
      predicate: (query) => query.queryKey[0] !== HEALTH_CHECK_QUERY_KEY[0],
    });
    void persister.flush();
  };

  return () => {
    void signOut();
  };
}
